// Даты календаря зарплатных периодов приходят как yyyy-MM-dd
export const ddmm = (iso?: string | null) => (iso ? `${iso.slice(8, 10)}.${iso.slice(5, 7)}` : '')

export const dateRange = (from?: string | null, to?: string | null) => (from && to ? `${ddmm(from)}–${ddmm(to)}` : '')

export const ddmmyyyy = (iso?: string | null) => (iso ? `${ddmm(iso)}.${iso.slice(0, 4)}` : '')

export const todayIso = () => {
    const d = new Date()
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}
